import { memo } from 'react';
import { SearchHistoryChipProps } from './props';
import { useDispatch } from 'react-redux';
import styles from './styles.module.scss';
import {
  removeSearchHistoryItem,
  setModalSearch,
} from '@/lib/store/casino/actions';

function SearchHistoryChip({ index, text }: SearchHistoryChipProps) {
  const dispatch = useDispatch();

  function handleRemoveSearchHistoryItem(index: number) {
    dispatch(removeSearchHistoryItem(index));
  }

  function handleSetSearch() {
    dispatch(setModalSearch(text));
  }

  return (
    <div className={styles.container}>
      <button
        className={styles['container__text-button']}
        onClick={handleSetSearch}
      >
        {text}
      </button>

      <button
        className={`${styles['container__text-button']} ${styles['container__text-button--larger']}`}
        onClick={() => handleRemoveSearchHistoryItem(index)}
      >
        <i className="fa-solid fa-xmark" />
      </button>
    </div>
  );
}

export default memo(SearchHistoryChip);
